import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import ArticlePagesTvBlockData from '../../../Models/Content/ArticlePagesTvBlockData';
import {ArticlePagesTvBlockMain} from './ArticlePagesTvBlockMain';

export default class ArticlePagesTvBlock extends EpiComponent<ArticlePagesTvBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <ArticlePagesTvBlockMain context={this.getContext()} contentData={this.props.data} />;
  }
}
